import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <section
      className="pt-[130px] md:pt-[150px] pb-24 md:pb-32 min-h-[70vh]"
      style={{ background: "var(--surface)" }}
      data-testid="payment-cancel"
    >
      <div className="wrap max-w-[640px] mx-auto text-center">
        <div className="mx-auto mb-8 w-16 h-16 rounded-full flex items-center justify-center"
          style={{ background: "var(--surface-secondary)", color: "var(--on-surface-muted)", border: "1px solid var(--border-c)" }}>
          <XCircle className="w-8 h-8" />
        </div>
        <h1 className="text-3xl md:text-5xl font-extrabold mb-4" style={{ color: "var(--on-surface)" }}>
          No worries — you're back at the trailhead.
        </h1>
        <p className="body-lg max-w-lg mx-auto mb-8">
          Your card wasn't charged. Come back any time — your Founding Member
          slot is still available.
        </p>
        <div className="flex flex-wrap gap-3 justify-center">
          <Link to="/pricing" className="btn btn-amber">Back to pricing</Link>
          <Link to="/" className="btn btn-light">Home</Link>
        </div>
      </div>
    </section>
  );
}
